import { IFacility, FacilityCCOption } from '@zunta/configurations'

type CreditCardToggleOptions = {
  show?: boolean;
  toggle?: FacilityCCOption;
}

function getToggle (
  facility: Partial<IFacility>,
  option: FacilityCCOption
): boolean {
  switch (option) {
    case 'isResidentPortalNoCC':
      return !facility.isResidentPortalNoCC
    case 'allowCCProcessing':
      return !facility.allowCCProcessing
  }
}
export { CreditCardToggleOptions, getToggle }
